var map = {
	"./1.png": 252,
	"./10.jpg": 594,
	"./11.jpg": 263,
	"./12.jpg": 928,
	"./2.jpg": 431,
	"./3.jpg": 42,
	"./4.jpg": 761,
	"./5.jpg": 884,
	"./6.jpg": 539,
	"./7.jpg": 494,
	"./8.jpg": 149,
	"./9.jpg": 256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;